module.exports = __webpack_public_path__ + "MaterialIcons-Regular.c58629e330eaf128316a.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/iconfont/MaterialIcons-Regular.woff2
// module id = 644
// module chunks = 0